module.exports = __webpack_public_path__ + "img/shachepian.dae18e39.png";